import { OrigoEventName } from '../graphql/hid/getOrigoAccount'
import { colors } from '../const/colors'
import i18n from 'i18next'

const deletedStatuses = [
  OrigoEventName.CREDENTIAL_REVOKED,
  OrigoEventName.ENDPOINT_TERMINATED,
  OrigoEventName.ENDPOINT_DELETE_INITIATED,
  OrigoEventName.CREDENTIAL_REVOKING,
]

const activeStatuses = [
  OrigoEventName.CREDENTIAL_ISSUED,
  OrigoEventName.ENDPOINT_ACTIVE,
]

const pendingStatuses = [
  OrigoEventName.INVITATION_PENDING,
  OrigoEventName.INVITATION_ACKNOWLEDGED,
  OrigoEventName.CREDENTIAL_ISSUE_INITIATED,
  OrigoEventName.CREDENTIAL_ISSUING,
  OrigoEventName.CREDENTIAL_RESERVED,
  OrigoEventName.CREDENTIAL_CREATING,
]

export const handleStatus = (
  status: OrigoEventName,
  accessGranted: boolean,
) => {
  if (activeStatuses.includes(status) && accessGranted) {
    return i18n.t('hid_status:ACTIVE')
  } else return i18n.t(`hid_status:${status}`)
}

export const handleStatusDescription = (
  status: OrigoEventName,
  accessGranted: boolean,
) => {
  if (activeStatuses.includes(status) && accessGranted) {
    return i18n.t('hid_status_description:ACTIVE')
  } else return i18n.t(`hid_status_description:${status}`)
}

export const getStatusColor = (status: string, accessGranted: boolean) => {
  if (activeStatuses.includes(status as OrigoEventName) && accessGranted) {
    return colors.green
  }
  if (activeStatuses.includes(status as OrigoEventName) && !accessGranted) {
    return colors.yellow
  }
  if (pendingStatuses.includes(status as OrigoEventName)) {
    return colors.yellow
  }
  if (deletedStatuses.includes(status as OrigoEventName)) {
    return colors.red
  }
  return colors.slate
}
